// thrux-upsell-dialog.js — "offer buy more" dialog on the picker CTA.
//
// When the customer submits with the 1-can pack selected, offer the 3-can Starter
// Kit; with 3 selected, offer Double It (6). Otherwise no dialog. Never auto-opens,
// at most once per session per pack size, reduced-motion safe, disabled store-wide by
// the buy-box attribute data-upsell-dialog="false" (settings.thrux_upsell_dialog).
//
// Mechanics (unchanged from the prior model, retargeted to the new picker): a single
// document-level CAPTURE-phase submit listener runs BEFORE product-page.js's bubble
// submit handler. When it decides to offer it preventDefault + stopImmediatePropagation
// (no add yet) and opens the dialog. Accept clicks the target pack tile — which runs
// product-page.js's tier side effects (cans, preset mix, price) — then re-submits the
// SAME form once; a per-form __thruxUpsellProceed flag lets that single re-submit pass
// straight through to product-page.js so the add + pixel fire exactly once. Prices are
// read from the tile's data-onetime-cents / data-subscribe-cents (integer cents from
// the config, never typed).
(function () {
  if (window.__thruxUpsellDialogInit) return;
  window.__thruxUpsellDialogInit = true;

  var shownThisLoad = {};
  function shownKey(cans) { return 'thrux_upsell_shown_' + cans; }
  function wasShown(cans) {
    if (shownThisLoad[cans]) return true;
    try { return sessionStorage.getItem(shownKey(cans)) === '1'; } catch (e) { return false; }
  }
  function markShown(cans) {
    shownThisLoad[cans] = true;
    try { sessionStorage.setItem(shownKey(cans), '1'); } catch (e) {}
  }
  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }

  function portalDialogs() {
    document.querySelectorAll('[data-buy-box-upsell]').forEach(function (d) {
      if (d.parentNode !== document.body) document.body.appendChild(d);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portalDialogs);
  else portalDialogs();

  function dialogFor(buyBox) {
    var id = buyBox.id;
    if (id) {
      var d = document.querySelector('[data-buy-box-upsell][data-upsell-for="' + id + '"]');
      if (d) return d;
    }
    return buyBox.querySelector('[data-buy-box-upsell]');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-buy-box-form]')) return;
    var buyBox = form.closest('[data-buy-box]');
    if (!buyBox) return;

    if (form.__thruxUpsellProceed) { form.__thruxUpsellProceed = false; return; }
    if (buyBox.getAttribute('data-upsell-dialog') !== 'true') return;
    var dialog = dialogFor(buyBox);
    if (!dialog) return;

    var current = buyBox.querySelector('[data-tier][data-selected]');
    if (!current) return;
    var curCans = parseInt(current.getAttribute('data-cans'), 10);
    if (!curCans) return;

    var targetCans = null, offerType = null;
    if (curCans === 1) { targetCans = 3; offerType = 'starter'; }
    else if (curCans === 3) { targetCans = 6; offerType = 'double'; }
    if (!targetCans) return;
    var target = buyBox.querySelector('[data-tier][data-cans="' + targetCans + '"]');
    if (!target) return;            // that pack not offered -> normal add
    if (wasShown(curCans)) return;  // at most once per session per size

    var isSub = buyBox.getAttribute('data-purchase-type') === 'subscribe';
    function tierCents(el) {
      var v = parseInt(el.getAttribute(isSub ? 'data-subscribe-cents' : 'data-onetime-cents'), 10);
      return isNaN(v) ? 0 : v;
    }
    var curTotal = tierCents(current), tgtTotal = tierCents(target);
    var deltaCans = targetCans - curCans, deltaCost = tgtTotal - curTotal, perCan = Math.round(tgtTotal / targetCans);
    if (deltaCans <= 0 || deltaCost <= 0) return; // never upsell to a worse/equal deal

    e.preventDefault();
    e.stopImmediatePropagation();
    markShown(curCans);
    openDialog(dialog, { offerType: offerType, deltaCans: deltaCans, deltaCost: deltaCost, perCan: perCan, target: target, form: form });
  }, true);

  function openDialog(dialog, ctx) {
    var isStarter = ctx.offerType === 'starter';
    var titleEl = dialog.querySelector('[data-upsell-title]');
    var subEl = dialog.querySelector('[data-upsell-sub]');
    var accept = dialog.querySelector('[data-upsell-accept]');
    var decline = dialog.querySelector('[data-upsell-decline]');
    var closeBtn = dialog.querySelector('[data-upsell-close]');
    var backdrop = dialog.querySelector('[data-upsell-backdrop]');
    var canWord = ctx.deltaCans === 1 ? 'can' : 'cans';

    if (titleEl) titleEl.textContent = isStarter ? 'Make it the Starter Kit?' : 'Double it?';
    if (subEl) {
      subEl.textContent = isStarter
        ? '3 cans, one of each flavor. Add ' + ctx.deltaCans + ' more ' + canWord + ' for ' + money(ctx.deltaCost) + '. That is ' + money(ctx.perCan) + ' a can.'
        : '6 cans at ' + money(ctx.perCan) + ' a can. Add ' + ctx.deltaCans + ' more ' + canWord + ' for ' + money(ctx.deltaCost) + '.';
    }
    if (accept) accept.textContent = isStarter ? 'Yes, make it 3 cans' : 'Yes, double it';

    var lastFocus = document.activeElement;
    function cleanup() {
      dialog.hidden = true;
      document.removeEventListener('keydown', onKey, true);
      if (accept) accept.onclick = null;
      if (decline) decline.onclick = null;
      if (closeBtn) closeBtn.onclick = null;
      if (backdrop) backdrop.onclick = null;
      try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
    }
    function proceed(useTarget) {
      cleanup();
      if (useTarget && ctx.target) ctx.target.click(); // runs product-page.js tier side effects (cans + preset mix + price)
      ctx.form.__thruxUpsellProceed = true;
      setTimeout(function () { if (ctx.form.requestSubmit) ctx.form.requestSubmit(); else ctx.form.submit(); }, 0);
    }
    function onKey(ev) {
      if (ev.key === 'Escape') { ev.preventDefault(); proceed(false); return; }
      if (ev.key === 'Tab') { trapFocus(ev); }
    }
    function trapFocus(ev) {
      var f = dialog.querySelectorAll('button:not([hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }

    if (accept) accept.onclick = function () { proceed(true); };
    if (decline) decline.onclick = function () { proceed(false); };
    if (closeBtn) closeBtn.onclick = function () { proceed(false); };
    if (backdrop) backdrop.onclick = function () { proceed(false); };
    document.addEventListener('keydown', onKey, true);

    dialog.hidden = false;
    if (accept) { try { accept.focus(); } catch (e) {} }
  }
})();
